import { requestPlan } from "../config/requestPlan";

export const saveRequestPlan = (data) => {
    return requestPlan.save(data).then(response => response)
};